export default __webpack_public_path__ + "static/media/Mazda-Landing.067a1094.png";